var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 53,
    viewBox: "0 0 104 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_2763)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.579,
    height: 52.8684,
    rx: 2.90977,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 23.6419C2.90977 25.9455 8.72932 30.9891 8.72932 32.735L13.4577 29.8252L18.9135 41.4643L24.3694 35.6448L29.4615 25.0968L34.5536 32.0075L39.6457 29.0978L45.4652 36.7359L50.5573 34.5536H55.6494L65.8336 19.641L71.2895 29.8252L76.3816 22.9145L81.8374 25.8243L86.9295 15.6401L92.0216 18.9136L97.4774 16.7312L102.933 12.7303L104.752 15.6401",
    stroke: "#A2ABCC",
    strokeWidth: 0.727443,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 45.8291L2.54605 43.283L6.18327 45.8291L9.45676 44.7379L13.4577 47.6477L16.7312 46.5565H20.3684L27.2791 41.4644L30.9163 44.7379L34.5536 42.5556L38.5545 44.0105L41.828 40.3732L45.4652 41.4644L52.7397 39.2821L55.2857 41.4644H60.0141L63.2876 40.0095L66.5611 40.3732L70.1983 44.7379H74.1992L77.4727 46.5565L81.1099 44.0105L85.1109 45.8291L88.3844 42.5556L92.3853 43.283L95.6588 41.4644H99.296L102.57 38.1909L104.752 39.2821",
    stroke: "#4A599A",
    strokeWidth: 0.727443,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_2763"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 103.579,
    height: 52.8684,
    rx: 2.90977,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLine);
export default __webpack_public_path__ + "static/media/line.5d2f2d111f85924ad800c7664d521a25.svg";
export { ForwardRef as ReactComponent };